'use strict';

$(document).ready(function () {
    $('.skeleton-placeholder').hide();
    $('.home-main').show();
});
